import { render, staticRenderFns } from "./CouponListTable.vue?vue&type=template&id=1bbbfdb1&"
import script from "./CouponListTable.vue?vue&type=script&lang=js&"
export * from "./CouponListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports